import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { fetchMe, fetchMemberships } from '@/api/auth'

export default function RequireAuth({ children }) {
  const nav = useNavigate()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    ; (async () => {
      try {
        localStorage.removeItem('userId')
        localStorage.removeItem('roles')
        localStorage.removeItem('meCache')
        localStorage.removeItem('meInfoCache')
        localStorage.removeItem('membershipsCache')
        const [{ data: me }, { data: mem }] = await Promise.all([
          fetchMe(),
          fetchMemberships(),
        ])

        // อัปเดตเฉพาะสิ่งที่ต้องใช้ใน session
        if (me?.user_id) localStorage.setItem('userId', me.user_id)
        if (mem?.role) localStorage.setItem('roles', JSON.stringify(mem.role))
        // const activeOrgId = mem?.active_org_id 
        // const activeMembership = mem?.memberships?.find(m => m.organization_id === activeOrgId) 
        // if (activeMembership?.roles) {
        //   localStorage.setItem('roles', JSON.stringify(activeMembership.roles))
        // }

        // ✅ orgId: เอาจาก server active_org_id เท่านั้น
        if (mem?.active_org_id) {
          localStorage.setItem('orgId', mem.active_org_id)
        }

        setReady(true)
      } catch {
        nav('/login', { replace: true })
      }
    })()
  }, [nav])

  if (!ready)
    return (
      <div className="flex items-center justify-center h-screen bg-info">
        <span className="w-10 h-10 border-4 border-secondary border-t-transparent rounded-full animate-spin" />
      </div>
    )
  return children
}
